import { group as actions } from '../actions'
export const initialState = {
  groups: [],
  editors: {
    update: {
      ':db/id': ''
    }
  }
}

export const setEditors = editors => dispatch => {
  dispatch({
    type: actions.SET_EDITORS,
    editors
  })
}

export const updateEditors = updateFn => dispatch => {
  dispatch({
    type: actions.UPDATE_EDITORS,
    updateFn
  })
}
